module.exports = __webpack_public_path__ + "img/invoice-cancel.5383da82.svg";